import { ref, computed, watch } from 'vue'

class Storage {
  // On garde un cache réactif en mémoire
  static _reactiveStore = new Map()

  static save(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify(data))
      // ⚡ update la version réactive aussi
      if (this._reactiveStore.has(key)) {
        this._reactiveStore.get(key).value = data
      }
    } catch (err) {
      console.error('Erreur lors de la sauvegarde dans localStorage:', err)
    }
  }

  static get(key) {
    try {
      const item = localStorage.getItem(key)
      if (!item) return null
      return JSON.parse(item)
    } catch (err) {
      console.error('Erreur lors de la récupération dans localStorage:', err)
      return null
    }
  }

  static delete(key) {
    try {
      localStorage.removeItem(key)
      if (this._reactiveStore.has(key)) {
        this._reactiveStore.get(key).value = null
      }
    } catch (err) {
      console.error('Erreur lors de la suppression dans localStorage:', err)
    }
  }

  static useValue(key, defaultValue = null, canUpdate = false) {
    // créer le ref si il n'existe pas
    if (!this._reactiveStore.has(key)) {
      const saved = this.get(key)
      const state = ref(saved ?? defaultValue)
      this._reactiveStore.set(key, state)
    }

    const stateRef = this._reactiveStore.get(key)

    // watch pour détecter les changements et sauvegarder si canUpdate
    watch(
      stateRef,
      newVal => {
        if (canUpdate) {
          this.save(key, newVal)
        } else {
          console.warn('Update not allowed for ' + key)
        }
      },
      { deep: true },
    )

    // retourne un computed pour l'interface
    return computed(() => stateRef.value)
  }
}

export default Storage
